export const UtilGestureMode = wcardinal.ui.UtilGestureMode;